/**
 * Cart checkout reconciler.
 *
 * When the customer clicks Checkout, pistesarjat-cart-to-order.js stores a
 * marker `pistesarjat:pendingCheckout` in localStorage and redirects to the
 * Shopify draft order invoice URL WITHOUT clearing the Shopify cart.
 *
 * This script runs on every page load and asks the integration backend
 * whether the corresponding cart_token has produced an actual order
 * (orders/create webhook records the cart_token to DynamoDB with 24h TTL).
 *
 * - completed=true   -> clear the Shopify cart, drop the marker.
 * - completed=false  -> leave the cart intact (silent UX). Drop marker
 *                       only when it's older than the 24h TTL.
 */
(function () {
  var STORAGE_KEY = 'pistesarjat:pendingCheckout';
  var MAX_AGE_MS = 24 * 60 * 60 * 1000; // 24h, matches backend TTL

  document.addEventListener('DOMContentLoaded', function () {
    var raw;
    try {
      raw = localStorage.getItem(STORAGE_KEY);
    } catch (e) {
      return;
    }
    if (!raw) {
      return;
    }

    var pending;
    try {
      pending = JSON.parse(raw);
    } catch (e) {
      localStorage.removeItem(STORAGE_KEY);
      return;
    }

    if (!pending || !pending.cartToken || !pending.ts) {
      localStorage.removeItem(STORAGE_KEY);
      return;
    }

    if (Date.now() - pending.ts > MAX_AGE_MS) {
      localStorage.removeItem(STORAGE_KEY);
      return;
    }

    var url =
      window.Shopify.routes.root +
      'apps/bc/checkout-status?cartToken=' +
      encodeURIComponent(pending.cartToken);

    fetch(url, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('checkout-status responded ' + response.status);
        }
        return response.json();
      })
      .then(function (status) {
        if (status && status.completed) {
          return fetch(window.Shopify.routes.root + 'cart/clear.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
          }).then(function () {
            localStorage.removeItem(STORAGE_KEY);
          });
        }
        // Not completed yet: keep cart and marker so a future page load can retry.
      })
      .catch(function (err) {
        console.error('Checkout reconciler failed', err);
      });
  });
})();
